var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerified = function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A40FF",
    d: "M14.918 4.165c.171.415.5.745.915.918l1.455.602a1.694 1.694 0 0 1 .916 2.213l-.602 1.454a1.7 1.7 0 0 0 0 1.297l.602 1.453a1.694 1.694 0 0 1-.917 2.213l-1.453.602a1.7 1.7 0 0 0-.918.916l-.602 1.455a1.694 1.694 0 0 1-2.213.916l-1.453-.602a1.7 1.7 0 0 0-1.296.001l-1.455.602a1.694 1.694 0 0 1-2.211-.916l-.603-1.455a1.7 1.7 0 0 0-.916-.917l-1.454-.603a1.694 1.694 0 0 1-.917-2.212l.602-1.453a1.7 1.7 0 0 0-.001-1.296l-.601-1.456a1.694 1.694 0 0 1 .917-2.214l1.453-.602c.415-.171.744-.5.917-.914l.602-1.455a1.694 1.694 0 0 1 2.213-.916l1.453.602c.415.171.882.17 1.296-.001l1.455-.6a1.694 1.694 0 0 1 2.213.916l.603 1.455z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67,
    d: "m7.5 10 1.667 1.667 3.75-3.75"
  })));
};
export default SvgVerified;